module.exports = require('./helpers/bundle-url').getBundleURL('8fOTM') + "logo-dark.ba5147f0.svg";